import { useEffect, useState, useMemo } from 'react'
import { useAccount, useReadContract } from 'wagmi'
import { erc20Abi, Address } from 'viem'
import { useV6SDK } from '~/hooks/useV6SDK'
import { FixedPointNumber } from '~/utils/fixedPoint'

export const useTokenAllowance = (
  token?: ERC20Token,
  owner?: string,
  spender?: string,
) => {
  const { data: allowance } = useReadContract({
    address: token?.address as Address,
    abi: erc20Abi,
    functionName: 'allowance',
    args: [owner as Address, spender as Address],
    query: {
      enabled: !!(token && owner && spender),
      refetchInterval: 3000,
    },
  })

  return useMemo(
    () =>
      token && allowance !== undefined
        ? new FixedPointNumber(allowance.toString(), token.decimals)
        : undefined,
    [token?.address, allowance],
  )
}

// deprecated
export const useTokensAllowance = (
  tokens: ERC20Token[],
  owner: string,
  spender: string,
) => {}

export const useTokenPermit = (token: Address, spender: Address) => {
  const { address: account } = useAccount()
  const sdk = useV6SDK()
  const [amount, setAmount] = useState(0n)
  const [expiration, setExpiration] = useState(0)

  const getTokenPermit = async () => {
    try {
      const { amount, expiration } = await sdk.permit.getTokenPermit({
        account,
        token,
        spender,
      })
      setAmount(amount)
      setExpiration(expiration)
    } catch (err) {
      console.log('failed to get token permit', err)
    }
  }

  useEffect(() => {
    if (token && spender && account) {
      getTokenPermit()
    }
  }, [token, spender, account])

  return {
    tokenPermitAmount: amount,
    tokenPermitExpiration: expiration,
  }
}
